import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class FeaturesService {
  get(): object {
    return environment.featureData;
  }
}
